import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { RESIDENCE_ACTION_TYPE } from '../actions';

const initialState = {};

const residencesReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case RESIDENCE_ACTION_TYPE.GET_RESIDENCES:
        return payload || initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default residencesReducer;
